package diagnosis.component


import antd.badge.badge
import antd.button.button
import antd.card.card
import antd.descriptions.descriptions
import antd.descriptions.descriptionsItem
import antd.form.form
import antd.form.formItem
import antd.grid.col
import antd.grid.row
import antd.icon.checkOutlined
import antd.icon.closeOutlined
import antd.icon.editOutlined
import antd.layout.space
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.modal.modal
import antd.radio.radioButton
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.optGroup
import antd.select.option
import antd.select.select
import antd.tag.tag
import antd.timeline.timeline
import antd.timeline.timelineItem
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom
import com.jingfangpai.common.orm.mapping.Syndrome
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptom
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.enums.*
import com.jingfangpai.medicalRecord.model.MedicalRecordAndDiagnosis
import com.jingfangpai.medicalRecord.model.MedicalRecordDiagnosisSuggestionDto
import com.jingfangpai.medicalRecord.model.MedicalRecordSignSymptomDto
import com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem
import com.jingfangpai.syndrome.model.SyndromeDetail
import com.jingfangpai.syndrome.model.SyndromeIndicationDetail
import com.jingfangpai.syndrome.model.SyndromeIndicationSignSymptomDetail
import react.*
import diagnosis.container.DiagnosisPageContext
import external.select.filterOptionFun
import kotlinext.js.Object
import kotlinext.js.js
import kotlinx.html.js.onClickFunction
import kotlinx.html.unsafe
import kotlinx.html.visible
import react.dom.*
import user.service.AuthService
import user.service.CurrentUserPermission

external interface DiagnosisProps : RProps {
    var medicalRecordId:String
}

data class DiagnosisContextData(var placeHolderFunction: (param: String) -> Unit)

val Diagnosis = functionalComponent<DiagnosisProps> { props ->

    val ctx = useContext(DiagnosisPageContext)
    val (medicalRecordAndDiagnosis,setMedicalRecordAndDiagnosis) = useState(MedicalRecordAndDiagnosis())
    val (editingMedicalRecordSignSymptom,setEditingMedicalRecordSignSymptom) = useState(MedicalRecordSignSymptom())
    val (editingMedicalRecordSignSymptomName,setEditingMedicalRecordSignSymptomName) = useState<SignSymptomName?>(null)
    val (showSignSymptomEditModal,setShowSignSymptomEditModal) = useState(false)
    val (symptomOptions,setSignSymptomOptions) = useState(arrayOf<CascadedOption<String>>())
    val (existingSignSymptomIds,setExistingSignSymptomIds) = useState(arrayOf<String>())
    val (existingSignSymptomNames,setExistingSignSymptomNames) = useState(arrayOf<SignSymptomName>())

    fun generateDiagnosis(){
        message.loading("正在获取诊断建议")
        ctx.generateDiagnosis(props.medicalRecordId,{ resp->
            if(resp.ok()){
                val _medicalRecordAndDiagnosis = Object.assign(MedicalRecordAndDiagnosis(),medicalRecordAndDiagnosis)
                _medicalRecordAndDiagnosis.diagnosisSuggestion = resp.data!!
                setMedicalRecordAndDiagnosis(_medicalRecordAndDiagnosis)
            }else{
                message.error("获取诊断建议出错：${resp.message}")
            }
        },{
            message.error("获取诊断建议出错：${it.message}")
        })
    }

    fun loadMedicalRecordAndDiagnosis(){
        ctx.getMedicalRecordAndDiagnosis(props.medicalRecordId,{ resp->
           if(resp.ok()){
               setMedicalRecordAndDiagnosis(resp.data!!)
               setExistingSignSymptomIds(resp.data!!.medicalRecord?.symptoms?.map { it.signSymptomId?:"" }?.toTypedArray()?:arrayOf())
               setExistingSignSymptomNames(resp.data!!.medicalRecord?.symptoms?.filter { MedicalRecordSignSymptomState.存在 == it.state }?.map { it.signSymptomName!! }?.toTypedArray()?:arrayOf())
           }else{
               message.error("加载出错：${resp.message}")
           }
        },{
            message.error("加载出错：${it.message}")
        })
    }

    useEffectOnce {
        loadMedicalRecordAndDiagnosis()
        ctx.getSignSymptomOptions({ resp->
            if(resp.ok()) {
                resp.data?.let{
                    setSignSymptomOptions(it)
                }
            }else{
                message.error("获取体征症状出错：${resp.message}")
            }
        },{
            message.error("获取体征症状出错：${it.message}")
        })
    }

    div("Diagnosis") {
        card {
            attrs{
                title = "${medicalRecordAndDiagnosis.medicalRecord?.patientName?:""}病案诊断（${medicalRecordAndDiagnosis.medicalRecord?.createdOn?.toDateTimeString()?:""}）"
            }
            row {
                attrs{
                    gutter = "16"
                }
                col {
                    attrs{
                        span = "12"
                    }
                    card{
                        attrs{
                            title = "症状及体征"
                            bordered = false
                            extra = buildElement{
                                button{
                                    attrs{
                                        onClick = {
                                            setEditingMedicalRecordSignSymptom(MedicalRecordSignSymptom().apply{
                                                recordId = props.medicalRecordId
                                                state = MedicalRecordSignSymptomState.存在
                                                order = if(true == medicalRecordAndDiagnosis.medicalRecord?.symptoms?.isNullOrEmpty()) 1 else (medicalRecordAndDiagnosis.medicalRecord?.symptoms?.maxOf { it.order?:0 }?:1)
                                                isDeleted = false
                                            })
                                            setShowSignSymptomEditModal(true)
                                        }
                                    }
                                    +"添加"
                                }
                            }
                        }
                        val existingSymptoms = medicalRecordAndDiagnosis.medicalRecord?.symptoms?.filter{MedicalRecordSignSymptomState.存在 == it.state}?:listOf()
                        val nonExistingSymptoms = medicalRecordAndDiagnosis.medicalRecord?.symptoms?.filter{MedicalRecordSignSymptomState.不存在 == it.state}?:listOf()
                        list<MedicalRecordSignSymptomDto, ListComponent<MedicalRecordSignSymptomDto>>{
                            attrs{
                                itemLayout = "horizontal"
                                size="small"
                                dataSource = (existingSymptoms + nonExistingSymptoms).toTypedArray()
                                renderItem = { medicalRecordSignSymptomDetail: MedicalRecordSignSymptomDto, signSymptomIndex: Number ->
                                    val _signSymptomIndex = signSymptomIndex.toInt()
                                    listItem {
                                        attrs{
                                            actions = arrayOf(
                                                buildElement {
                                                    span{
                                                        /*button{
                                                            attrs{
                                                                type = "link"
                                                                onClick = {
                                                                    val existingIds = medicalRecordSignSymptomDetail.characteristics.map{it.signSymptomCharacteristicId}
                                                                    setCurrentCharacteristicOptions(characteristics[medicalRecordSignSymptomDetail.symptomId]!!.filter{!existingIds.contains(it.id)})
                                                                    //setCurrentCharacteristicOptions(characteristics[syndromeIndicationSignSymptomDetail.symptomId]!!)
                                                                    setEditingSyndromeIndicationSignSymptomCharacteristic(
                                                                        SyndromeIndicationSignSymptomCharacteristic().apply{
                                                                            syndromeIndicationSignSymptomId = medicalRecordSignSymptomDetail.id
                                                                            createdBy = AuthService.getUserAuthData()?.id
                                                                            status = SyndromeIndicationSignSymptomCharacteristicStatus.正常
                                                                        })
                                                                    setShowSyndromeIndicationSignSymptomCharacteristicEditForm(true)
                                                                }
                                                            }
                                                            +"修改"
                                                        }*/
                                                        /*if(SyndromeIndicationSignSymptomType.组合 == medicalRecordSignSymptomDetail.type){



                                                        }else if(characteristics.containsKey(medicalRecordSignSymptomDetail.symptomId) && medicalRecordSignSymptomDetail.characteristics.size<characteristics[medicalRecordSignSymptomDetail.symptomId]!!.size){
                                                            button{
                                                                attrs{
                                                                    type = "link"
                                                                    onClick = {
                                                                        val existingIds = medicalRecordSignSymptomDetail.characteristics.map{it.signSymptomCharacteristicId}
                                                                        setCurrentCharacteristicOptions(characteristics[medicalRecordSignSymptomDetail.symptomId]!!.filter{!existingIds.contains(it.id)})
                                                                        //setCurrentCharacteristicOptions(characteristics[syndromeIndicationSignSymptomDetail.symptomId]!!)
                                                                        setEditingSyndromeIndicationSignSymptomCharacteristic(
                                                                            SyndromeIndicationSignSymptomCharacteristic().apply{
                                                                            syndromeIndicationSignSymptomId = medicalRecordSignSymptomDetail.id
                                                                            createdBy = AuthService.getUserAuthData()?.id
                                                                            status = SyndromeIndicationSignSymptomCharacteristicStatus.正常
                                                                        })
                                                                        setShowSyndromeIndicationSignSymptomCharacteristicEditForm(true)
                                                                    }
                                                                }
                                                                +"添加特征"
                                                            }
                                                        }*/
                                                    }
                                                },
                                                buildElement {
                                                    button{
                                                        attrs{
                                                            type = "link"
                                                            onClick = {
                                                                setEditingMedicalRecordSignSymptom(medicalRecordSignSymptomDetail)
                                                                setShowSignSymptomEditModal(true)
                                                                setEditingMedicalRecordSignSymptomName(medicalRecordSignSymptomDetail.signSymptomName)
                                                            }
                                                        }
                                                        +"修改"
                                                    }
                                                }
                                            )
                                        }
                                        listItemMeta {
                                            attrs{
                                                title = buildElement{
                                                    div{
                                                        span{
                                                            badge {
                                                                attrs{
                                                                    count = "${_signSymptomIndex+1}"
                                                                    if(MedicalRecordSignSymptomState.不存在 == medicalRecordSignSymptomDetail.state){
                                                                        color = "gray"
                                                                    }
                                                                }
                                                            }
                                                            attrs{
                                                                jsStyle = js{
                                                                    marginLeft = "8px"
                                                                }
                                                            }
                                                            +" ${medicalRecordSignSymptomDetail.signSymptomName?.getLiteral() ?: ""}${if(!medicalRecordSignSymptomDetail.signSymptomNameAlias.isNullOrBlank()) "（${medicalRecordSignSymptomDetail.signSymptomNameAlias}）" else ""}   "

                                                            /*tag{
                                                                attrs{
                                                                    color =  if(MedicalRecordSignSymptomState.不存在 == medicalRecordSignSymptomDetail.state || medicalRecordSignSymptomDetail.state == null) "gray" else "blue"
                                                                }
                                                                +"${medicalRecordSignSymptomDetail.state?:"不存在"}"
                                                            }*/
                                                            if(MedicalRecordSignSymptomState.不存在 == medicalRecordSignSymptomDetail.state){
                                                                closeOutlined {  }
                                                            }else{
                                                                checkOutlined {  }
                                                            }

                                                            if(medicalRecordSignSymptomDetail.severity != null){
                                                                span{
                                                                    attrs{
                                                                        jsStyle = kotlinext.js.js {
                                                                            fontWeight = "100"
                                                                        }
                                                                    }
                                                                    +"程度：${medicalRecordSignSymptomDetail?.severity?:""}"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                description = buildElement{
                                                    div {
                                                        if(!medicalRecordSignSymptomDetail.characteristics.isEmpty()){
                                                            div{
                                                                attrs{
                                                                    jsStyle = js{
                                                                        marginLeft = "20px"
                                                                    }
                                                                }
                                                                timeline{
                                                                    medicalRecordSignSymptomDetail.characteristics.forEach{ characteristic->
                                                                        timelineItem{
                                                                            em{
                                                                                +"${characteristic.name}${if(!characteristic.description.isNullOrBlank()) "(${characteristic.description})" else ""}"
                                                                            }
                                                                            span{
                                                                                +"："
                                                                            }
                                                                            if(MedicalRecordSignSymptomCharacteristicState.是 == characteristic.state){
                                                                                span{
                                                                                    attrs{
                                                                                        jsStyle = kotlinext.js.js {
                                                                                            textDecorationLine = "underline"
                                                                                            textDecorationStyle = "wavy"
                                                                                        }
                                                                                    }
                                                                                    +"${characteristic.state?.getLiteral() ?: ""}"
                                                                                }
                                                                            }else {
                                                                                +"${characteristic.state?.getLiteral() ?: ""}"
                                                                            }
                                                                            button{
                                                                                attrs{
                                                                                    type = "link"
                                                                                    onClick = {
                                                                                        /*setCurrentCharacteristicOptions(characteristics[medicalRecordSignSymptomDetail.symptomId]!!)
                                                                                        setEditingSyndromeIndicationSignSymptomCharacteristic(characteristic)
                                                                                        setShowSyndromeIndicationSignSymptomCharacteristicEditForm(true)*/
                                                                                    }
                                                                                }
                                                                                editOutlined {  }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        /*div{
                                                            +"${medicalRecordSignSymptomDetail.description ?: ""} 出处：${medicalRecordSignSymptomDetail?.source}"
                                                        }*/
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
                col {
                    attrs{
                        span = "12"
                    }
                    card{
                        attrs{
                            title = "诊断结果"
                            bordered = false
                            extra = buildElement{
                                space{
                                    button{
                                        attrs{
                                            type = "link"
                                            onClick = {
                                                generateDiagnosis()
                                            }
                                        }
                                        +if (medicalRecordAndDiagnosis.diagnosisSuggestion.isNullOrEmpty()) "提供建议" else "重新建议"
                                    }
                                    if(medicalRecordAndDiagnosis.diagnosis.isNullOrEmpty()){
                                        button{
                                            attrs{
                                                type = "link"
                                                onClick = {

                                                }
                                            }
                                            +"填写我的诊断"
                                        }
                                    }
                                }
                            }
                        }
                        if(medicalRecordAndDiagnosis.diagnosisSuggestion.isNullOrEmpty()){
                            +"尚未生成诊断建议"
                        }else{
                            list<MedicalRecordDiagnosisSuggestionDto, ListComponent<MedicalRecordDiagnosisSuggestionDto>> {
                                attrs {
                                    itemLayout = "vertical"
                                    size = "large"
                                    pagination = false
                                    dataSource = medicalRecordAndDiagnosis.diagnosisSuggestion
                                    renderItem = { item: MedicalRecordDiagnosisSuggestionDto, index: Number ->
                                        val idx = index.toInt()
                                        listItem {
                                            attrs {
                                                key = "${item.id}"
                                                extra = buildElement {
                                                    span{
                                                        a {
                                                            attrs{
                                                                jsStyle = js{
                                                                    float = "right"
                                                                }
                                                                onClickFunction = {

                                                                }
                                                            }
                                                            +"采纳"
                                                        }
                                                    }
                                                }
                                            }
                                            listItemMeta {
                                                attrs {
                                                    avatar = buildElement {
                                                        if(item.score!=null && item.score!!>0){
                                                            badge {
                                                                attrs{
                                                                    count = "${idx+1}"
                                                                }
                                                            }
                                                        }else{
                                                            closeOutlined {  }
                                                        }
                                                    }
                                                    title = buildElement {
                                                        div{
                                                            span{
                                                                +"${item.syndromeName ?: ""} 之 ${item.syndromeIndicationName}"
                                                                em{
                                                                    attrs{
                                                                        jsStyle = js{
                                                                            color = "gray"
                                                                            fontSize = "0.9em"
                                                                        }
                                                                    }
                                                                    +"${item.syndromeIndicationDescription ?: ""}"
                                                                }
                                                                span{
                                                                    +"（得分：${item.score?:"?"}）"
                                                                }
                                                            }
                                                            space {
                                                                attrs{
                                                                    style = js{
                                                                        fontWeight = "normal"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    description = buildElement {
                                                        div{
                                                            if(item.score != null && item.score!!>0){
                                                                if(item.votedBy != null){
                                                                    if(!item.votedBy?.oneIsEnoughAndFound.isNullOrEmpty()){
                                                                        div{
                                                                            attrs{
                                                                                jsStyle = js{
                                                                                    color = "#333"
                                                                                }
                                                                            }
                                                                            +"但见即是：${item.votedBy!!.oneIsEnoughAndFound.map { it.getDisplayName(existingSignSymptomNames) }.joinToString("、")}"
                                                                            //checkOutlined {  }
                                                                        }
                                                                    }
                                                                    if(!item.votedBy?.mustBeFoundAndFound.isNullOrEmpty()){
                                                                        div{
                                                                            attrs{
                                                                                jsStyle = js{
                                                                                    color = "#333"
                                                                                }
                                                                            }
                                                                            +"必见症状：${item.votedBy!!.mustBeFoundAndFound.map { it.getDisplayName(existingSignSymptomNames) }.joinToString("、")}"
                                                                            //checkOutlined {  }
                                                                        }
                                                                    }
                                                                    if(!item.votedBy?.optionalAndFound.isNullOrEmpty()){
                                                                        div{
                                                                            attrs{
                                                                                jsStyle = js{
                                                                                    color = "#333"
                                                                                }
                                                                            }
                                                                            +"可见症状：${item.votedBy!!.optionalAndFound.map { it.getDisplayName(existingSignSymptomNames) }.joinToString("、")}"
                                                                            //checkOutlined {  }
                                                                        }
                                                                    }
                                                                }
                                                                if(!item.ignored.isNullOrEmpty()){
                                                                    div{
                                                                        +"未见症状：${item.ignored.map { it.getDisplayName(existingSignSymptomNames) }.joinToString("、")}"
                                                                        //closeOutlined {  }
                                                                    }
                                                                }
                                                            }else{
                                                                if(item.rejectedBy != null){
                                                                    if(!item.rejectedBy?.oneIsTooMuchButFound.isNullOrEmpty()){
                                                                        div{
                                                                            +"但见即非：${item.rejectedBy!!.oneIsTooMuchButFound.map { it.getDisplayName(existingSignSymptomNames) }.joinToString("、")}"
                                                                        }
                                                                    }
                                                                    if(!item.rejectedBy?.mustBeFoundButNotFound.isNullOrEmpty()){
                                                                        div{
                                                                            +"必见未见：${item.rejectedBy!!.mustBeFoundButNotFound.map { it.getDisplayName(existingSignSymptomNames) }.joinToString("、")}"
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            /*attrs.unsafe {
                                                                +"${item.description?:"无说明"}"
                                                            }*/
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    header = buildElement {
                                        span {
                                            this.attrs {
                                                jsStyle = kotlinext.js.js {
                                                    fontWeight = "bold"
                                                }
                                            }
                                            +"共${medicalRecordAndDiagnosis.diagnosisSuggestion.filter { (it.score?:-1)>0 }.size}条诊断建议"
                                        }
                                        style = kotlinext.js.js {
                                            marginBottom = "5px"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        modal{
            attrs{
                title = if(editingMedicalRecordSignSymptom.id.isNullOrBlank()) "增加症状" else "修改症状"
                visible = showSignSymptomEditModal
                onOk = {
                    message.loading("保存中...")
                    ctx.saveSignSymptom(editingMedicalRecordSignSymptom,{ resp->
                        if(resp.ok()){
                            setShowSignSymptomEditModal(false)
                            loadMedicalRecordAndDiagnosis()
                        }else{
                            message.error("保存症状失败：${resp.message}")
                        }
                    },{
                        message.error("保存症状失败：${it.message}")
                    })
                }
                onCancel = {setShowSignSymptomEditModal(false)}
            }
            form {
                attrs{
                    layout = "horizontal"
                }
                formItem {
                    attrs{
                        label = "体征症状"
                    }
                    if(editingMedicalRecordSignSymptom.id.isNullOrBlank()){
                        select<String, SelectComponent<String>> {
                            attrs {
                                showSearch = true
                                style = kotlinext.js.js { width = 200 }
                                value = editingMedicalRecordSignSymptom.signSymptomId
                                labelInValue = false
                                placeholder = "选择症状"
                                optionLabelProp = "label"
                                filterOption = ::filterOptionFun
                                onChange = { value: String, option: dynamic ->
                                    console.log("option",option)
                                    val symptom = Object.assign(MedicalRecordSignSymptom(),editingMedicalRecordSignSymptom)
                                    symptom.signSymptomId = value
                                    //symptom.name = option.label
                                    setEditingMedicalRecordSignSymptom(symptom)
                                }
                            }
                            symptomOptions.forEach { optGroup ->
                                optGroup {
                                    attrs{
                                        label = "${optGroup.label}"
                                    }
                                    optGroup.children?.filter { !existingSignSymptomIds.contains(it.value) }
                                        ?.forEach { opt->
                                            option {
                                                attrs{
                                                    label = "${opt.label}"
                                                    value = "${opt.value}"
                                                }
                                                +"${opt.label}"
                                            }
                                        }
                                }
                            }
                        }
                    }else{
                        span{
                            +"${editingMedicalRecordSignSymptomName?.getLiteral()?:""}"
                        }
                    }
                }
                formItem {
                    attrs {
                        label = "是否存在"
                    }
                    radioGroup {
                        attrs {
                            value = editingMedicalRecordSignSymptom.state
                            onChange = { event ->
                                val symptom = Object.assign(MedicalRecordSignSymptom(),editingMedicalRecordSignSymptom)
                                symptom.state = event.target.value
                                setEditingMedicalRecordSignSymptom(symptom)
                            }
                        }
                        MedicalRecordSignSymptomState.values().forEach { stateOption ->
                            radioButton {
                                attrs {
                                    value = stateOption
                                }
                                +"${stateOption.getLiteral() ?: ""}"
                            }
                        }
                    }
                }
            }
        }
    }
}